<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="90%"
      top="10vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.detailForm.cancel()"
      v-el-dialog-drag
    >
      <AddForm
        v-if="types === 'add' || types === 'copy'"
        ref="detailForm"
        :disabled="disabled"
        :orderGoodsCode="orderGoodsCode"
        :orderCode="orderCode"
        @close="$emit('close')"
        @reload="$emit('reload')"
      />
    </el-dialog>
  </div>
</template>
<script>
import AddForm from './addForm.vue'
export default {
  components: { AddForm },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    types: { type: String, default: '' },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden !important;
}
</style>

<style lang="scss">
.feedback-dialog {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto !important;
  margin-top: 0 !important;
}
</style>
